import images from '../data/viewCoverImages.js';
import exhibitionImages from '../data/exhibitionDisplayImages.js';

// Match the immutable source URL, so a replaced illustration never gets an old cover.
export function viewCoverImage(source, maxDimension = 1024) {
  if(maxDimension<=0)return source;
  const cover = maxDimension > 0 && images[source];
  if(cover)return maxDimension <= 512 ? cover.thumbnail : cover.display;
  if(exhibitionImages[source])return exhibitionImages[source];
  try {
    const url=new URL(source,'https://www.henryw.me');
    if(['www.henryw.me','henryw.me'].includes(url.hostname)&&exhibitionImages[url.pathname])return exhibitionImages[url.pathname];
    if(url.hostname==='ask-henry.whenry6688.workers.dev'&&/^\/(?:view-assets\/[a-f0-9-]{36}|shares\/[A-Za-z0-9_-]{12,40}\/assets\/\d{1,3})$/i.test(url.pathname)){
      url.searchParams.set('display',maxDimension<=512?'384':'1024');return url.href;
    }
  } catch { /* The original image remains the fallback. */ }
  return source;
}
